import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import { PasswordToggle } from '@gate31/feature/PasswordToggle/PasswordToggle';
import { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';

export class PasswordToggleDesk extends PasswordToggle {
    static cn = new BaseJs.BuildCn('PasswordToggleDesk');

    constructor(template: keyof LiquidTemplates) {
        super({
            template,
            cn: PasswordToggleDesk.cn
        });
    }
}
